const config = {
  profile: {
    name: "Yash Kamble",
    role: "Frontend Developer",
    email: "yashkamble824@gmail.com",
    profilePic: "https://res.cloudinary.com/dlnvozmgw/image/upload/v1759424006/Profile_Pic_eg67az.jpg",
  },
  navigation: [
    { name: "Experience", to: "experiences" },
    { name: "Projects", to: "projects" },
    { name: "Contact", to: "contact" },
  ],
  blogs: [
    { name: "Medium", url: "https://medium.com/@yashkamble1234567890" },
    { name: "Hashnode", url: "https://hashnode.com/@KnightHuxley" },
  ],
};

export default config;
